export enum PredictionStatus {
  onGoing = 'onGoing',
  next = 'next',
  none = '',
}
